import styled from 'styled-components'

import {typography, colour, spacing} from '../../theme/index'

export const ExternalResultUrlText = styled.p`
  font-family: ${typography.fontPrimary};
  margin: ${spacing.spacing1} ${spacing.spacing0};
  color: ${colour.palette.greyscale60};
  cursor: default;
  ${props => {
    if (props.truncate) {
      return `
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
        `
    }
  }}
`
